import React, { useEffect, useState } from "react";
import { ViewForms } from "./view-forms";
import { PulseLoader } from "react-spinners";
import PropTypes from "prop-types";
import { GetDynamicFormsForAdminPage } from "../../../../../../../services/api/task-form-api";
import FluentUiIcon from "../../../../../../../assets/fluent-ui-icon";
import AutomationsGrid from "../automations/automations-grid";
import { GetWorkflowById } from "../../../../../../../services/api/workflow-api";
import { GetTaskTypeStatuses } from "../../../../../../../services/api/task-types-api";
// TAD-5849: the Automations variant includes groups with no members, so they don't
// disappear from Form/Field/Section Availability when an automation is edited.
import { GetProjectsUsersAndGroupsForAutomations } from "../../../../../../../services/api/project-api";

export const FormAutomationEnhanced = ({ formDataFromParent, formStatusesFromParent, formAutomationFromParent, SetFormAutomation, taskTypeId, taskType }) => {
  const taskTypeIdToInt = parseInt(taskTypeId);
  const [selectedForm, setSelectedForm] = useState(null);
  const [allForms, setAllForms] = useState({
    data: [],
    isLoading: true,
  });
  const [taskStatusList, setTaskStatusList] = useState([]);
  const [formStatuses, setFormStatuses] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  useEffect( () => {
    const LoadForms = async () => {
      try {
        if (formDataFromParent?.data) {
          setAllForms((prev) => ({
            ...prev,
            data: formDataFromParent.data,
            isLoading: false,
          }));
        } else {
          let result = [];
          if (taskTypeIdToInt > 0) {
            result = await GetDynamicFormsForAdminPage(taskTypeIdToInt);
          }
          setAllForms((prev) => ({
            ...prev,
            data: result.data,
            isLoading: false,
          }));
        }
      } catch (e) {
        console.log("Error [GetDynamicFormForAdminPage] => ", e);
      }
    };
    LoadForms();

    GetWorkflowById(taskType?.WorkflowId).then((res) => {
      const baseStatusList = [];
      const customStatusList = [];
      res?.data?.StatusListItems?.forEach(element => {
        if (element.IsBase) {
          baseStatusList.push(element);
        } else {
          customStatusList.push(element);
        }
      });

      const groupedOptions = [
        {
          label: "Base Status",
          options: baseStatusList
        },
        {
          label: "Custom Status",
          options: customStatusList
        }
      ];
      setTaskStatusList(groupedOptions);
    });

    if (formStatusesFromParent) {
      setFormStatuses(formStatusesFromParent);
    } else {
      GetTaskTypeStatuses(taskTypeId).then((res) => {
        if (res.status === 200) setFormStatuses(res.data || []);
      });
    }

    GetProjectsUsersAndGroupsForAutomations().then((userResults) => {
      if (userResults.status === 200) {
        const allUsers = [...userResults?.data?.UserMembers, ...userResults?.data?.GroupMembers];
        setAllUsers({ allUsers: allUsers });
      }
    });

  }, []);

  return (
    <div className="form-design">
      {selectedForm ? (
        <>
          <div className="mt-2 top-actions">
            <div
              className="back-button"
              onClick={() => {
                setSelectedForm(null);
              }}
            >
              <FluentUiIcon
                name={"ArrowLeftRegular"}
                color={"#0e75bb"}
                size={20}
              />
              <span>Back to Forms</span>
            </div>
          </div>
          <AutomationsGrid allForms={allForms.data} selectedForm={selectedForm} taskTypeId={taskTypeIdToInt} taskStatusList={taskStatusList} formStatuses={formStatuses} allUsers={allUsers} formAutomationFromParent={formAutomationFromParent} SetFormAutomation={SetFormAutomation} setSelectedForm={setSelectedForm} />
        </>
      ) : allForms.isLoading ? (
        <div className="pulse-loader" data-testid="loading-spinner">
          <PulseLoader></PulseLoader>
        </div>
      ) : (
        <ViewForms
          setSelectedForm={setSelectedForm}
          allForms={allForms}
        />
      )}
    </div>
  );
};

FormAutomationEnhanced.propTypes = {
  taskTypeId: PropTypes.string,
  taskType: PropTypes.object,
  formDataFromParent: PropTypes.shape({
    data: PropTypes.array,
  }),
  formStatusesFromParent: PropTypes.array,
  formAutomationFromParent: PropTypes.array,
  SetFormAutomation: PropTypes.func,
};
